import { useState, useEffect } from 'react';
import API from '../api/axios';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Skills from '../components/Skills';
import FeaturedServices from '../components/FeaturedServices';
import Projects from '../components/Projects';
import Experience from '../components/Experience';
import Testimonials from '../components/Testimonials';
import FAQSection from '../components/FAQSection';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  const [profile, setProfile] = useState(null);
  const [projects, setProjects] = useState([]);
  const [skills, setSkills] = useState([]);
  const [experiences, setExperiences] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [profileRes, projectsRes, skillsRes, expRes] = await Promise.allSettled([
          API.get('/profile'), API.get('/projects'), API.get('/skills'), API.get('/experience')
        ]);
        if (profileRes.status === 'fulfilled') setProfile(profileRes.value.data);
        if (projectsRes.status === 'fulfilled') setProjects(projectsRes.value.data);
        if (skillsRes.status === 'fulfilled') setSkills(skillsRes.value.data);
        if (expRes.status === 'fulfilled') setExperiences(expRes.value.data);
      } catch (err) { console.log('Using default data'); }
    };
    fetchData();
  }, []);

  return (
    <>
      <Navbar isHomePage />
      <Hero profile={profile} />
      <About profile={profile} />
      <FeaturedServices />
      <Skills skills={skills} />
      <Projects projects={projects} />
      <Experience experiences={experiences} />
      <Testimonials />
      <FAQSection />
      <Contact profile={profile} />
      <Footer profile={profile} />
    </>
  );
};

export default Home;
